import { html, View } from 'rune-ts';
import klass from './RealtimeView.module.scss';
import { IconView } from '@services/MarppleShop/renderApp/pages/Curation/components/IconView.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { classes } from '@services/MarppleShop/shared/util';
import { differenceInSeconds } from 'date-fns';
import { CardProductError } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';

export type TProps = {
  size: 'Medium' | 'Small';
  ordered_at: Date;
};

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=391-41682&m=dev
 */
export class RealtimeView extends View<TProps> {
  protected override template({ size, ordered_at }: TProps) {
    const seconds = differenceInSeconds(new Date(), new Date(ordered_at));

    if (size === 'Medium') {
      return html`<span class="${classes(klass.review, klass.size_medium)}">
        <span class="${classes(klass.icon, klass.size_medium)}">${new IconView({ type: 'Clock' })}</span>

        <span class="${classes(klass.text, klass.size_medium)}">
          <span class="${font('12_bold')}">${ET('card_product::realtime::seconds', { seconds })}</span>

          <span class="${font('12_medium')}">${ET('card_product::realtime::ago')}</span>
        </span>
      </span>`;
    } else if (size === 'Small') {
      return html`<span class="${classes(klass.review, klass.size_small)}">
        <span class="${classes(klass.icon, klass.size_small)}">${new IconView({ type: 'Clock' })}</span>

        <span class="${classes(klass.text, klass.size_small)}">
          <span class="${font('12_bold')}">${ET('card_product::realtime::seconds', { seconds })}</span>

          <span class="${font('12_medium')}">${ET('card_product::realtime::ago')}</span>
        </span>
      </span>`;
    } else {
      throw new CardProductError();
    }
  }
}
